import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'stylesheets-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>🖍 Stylesheets</h1>
            <p class='section-text' tabindex='0'>
                Mosaic allows you to specify a <b>stylesheets</b> property when using the
                Shadow DOM in order to keep your styles self-contained, but still separate
                from your component logic. If you are creating a component that uses the
                Shadow DOM and you do not include this option, then you will have to write
                all of your styles inside of the view function. This can get very cluttered,
                so it is recommended that you use this option when creating components that
                make use of the Shadow DOM.
            </p>

            <p class='section-text' tabindex='0'>
                The value of this option must be either an array of strings, an array of
                CSSStyleSheet objects, or a combination of them. The renderer will check
                if it is a string, in which case it will create the stylesheet at creation
                time. Otherwise, it will just use the CSSStyleSheet that you pass through.
            </p>
            <br>
            
            <p class='section-text' tabindex='0' style='text-align:center;'>
                That's all for the Mosaic documentation! If you have any other
                questions feel free to open an issue on Github.
            </p>
            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/descendants')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    Descendants
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});